import React, { useState } from 'react';
import { getThumbnailUrl } from '../../utils';
import './TutorialVideosGrid.css';

function TutorialVideoItem({ video, onVideoClick, onVideoDelete, isAdmin }) {
  const [imageError, setImageError] = useState(false);
  
  // Use the videoDisplayFormat property from the video data (2x1 is panel, 1x1 is card)
  const isPanel = video.videoDisplayFormat === '2x1';
  
  // Generate thumbnail URL on the fly if not provided or if we want to ensure it's correct
  const thumbnailUrl = (video.thumbnailUrl && video.thumbnailUrl.trim() !== "") 
    ? video.thumbnailUrl 
    : getThumbnailUrl(video.videoUrl, video.supportedVideoFormat);

  // If still no thumbnail, try one last time with just the URL
  const finalThumbnailUrl = thumbnailUrl || getThumbnailUrl(video.videoUrl);

  if (isPanel) {
    return (
      <div
        className="tutorial-video-panel"
        onClick={() => onVideoClick && onVideoClick(video.id)}
      >
        {/* Left side - Video */}
        <div className="panel-video-section">
          <div className="panel-video-thumbnail">
            {finalThumbnailUrl && !imageError ? (
              <img
                src={finalThumbnailUrl}
                alt={video.name}
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="video-thumbnail-placeholder">
                <i className="fa-solid fa-video"></i>
                <span>Video</span>
              </div>
            )}
            {/* Duration overlay - bottom right */}
            {video.duration && (
              <div className="panel-video-duration">
                {video.duration}
              </div>
            )}
            {/* Date overlay - bottom left */}
            {video.date && (
              <div className="panel-video-date">
                <i className="fa-solid fa-calendar"></i> {new Date(video.date).toLocaleDateString()}
              </div>
            )}
            {/* Likes overlay - top right */}
            <div className="panel-video-likes">
              <i className="fa-solid fa-thumbs-up"></i> {video.likes || 0}
            </div>
            <div className="panel-video-overlay">
              <i className="fa-solid fa-play"></i>
            </div>
          </div>
        </div>

        {/* Right side - Content */}
        <div className="panel-content-section">
          <h3 className="panel-video-title">{video.name}</h3>
          <p className="panel-video-description">{video.shortDescription || video.description}</p>
          <div className="panel-video-tags">
            {video.tags && video.tags.length > 0 && video.tags.map((tag, index) => (
              <span key={index} className="panel-tag">{tag}</span>
            ))}
          </div>
          {isAdmin && (
            <div className="panel-admin-controls">
              <button
                className="admin-control-btn admin-control-btn--edit"
                onClick={(e) => {
                  e.stopPropagation();
                  onVideoClick && onVideoClick(video.id);
                }}
                title="Edit video"
              >
                <i className="fa-solid fa-edit"></i>
              </button>
              <button
                className="admin-control-btn admin-control-btn--delete"
                onClick={(e) => {
                  e.stopPropagation();
                  onVideoDelete && onVideoDelete(video);
                }}
                title="Delete video"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="tutorial-video-card"
        onClick={() => onVideoClick && onVideoClick(video.id)}
      >
        <div className="card-video-thumbnail">
          {finalThumbnailUrl && !imageError ? (
            <img 
              src={finalThumbnailUrl} 
              alt={video.name} 
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="video-thumbnail-placeholder">
              <i className="fa-solid fa-video"></i>
              <span>Video</span>
            </div>
          )}
          <div className="card-video-overlay">
            <i className="fa-solid fa-play"></i>
          </div>
          <div className="card-video-title-overlay">
            <h4 className="card-video-title">{video.name}</h4>
          </div>
          {/* Likes overlay - top right */}
          <div className="card-video-likes">
            <i className="fa-solid fa-thumbs-up"></i> {video.likes || 0}
          </div>
          {isAdmin && (
            <div className="card-admin-controls">
              <button
                className="admin-control-btn admin-control-btn--edit"
                onClick={(e) => {
                  e.stopPropagation();
                  onVideoClick && onVideoClick(video.id);
                }}
                title="Edit video"
              >
                <i className="fa-solid fa-edit"></i>
              </button>
              <button
                className="admin-control-btn admin-control-btn--delete"
                onClick={(e) => {
                  e.stopPropagation();
                  onVideoDelete && onVideoDelete(video);
                }}
                title="Delete video"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export function TutorialVideosGrid({ videos, currentCategory, onVideoClick, onVideoDelete, isAdmin = false }) {
  return (
    <div className="tutorial-videos-grid">
      {videos.map((video) => (
        <TutorialVideoItem 
          key={video.id} 
          video={video} 
          onVideoClick={onVideoClick} 
          onVideoDelete={onVideoDelete} 
          isAdmin={isAdmin} 
        />
      ))}
    </div>
  );
}